<template>

  <v-dialog
    width     = "auto "
    v-model   = "dialogIsOpen"
    v-hotkey  = "keymap"
  >

    <template v-slot:activator="{ on, attrs }">
      <v-list-item
        v-on      = "on"
        v-bind    = "attrs"
      >
        <v-list-item-icon>
          <v-icon>mdi-keyboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Keyboard Shortcuts</v-list-item-content>
      </v-list-item>
    </template>

    <v-card>

      <v-card-title>Keyboard Shortcuts</v-card-title>

      <div class="categories_container">
        <div
          v-for = "category in categories"
          :key  = "category.name"
        >

          <div class="keys_container">

            <div class="label text-h6">{{ category.name }}</div>

            <template v-for = "(shortcut, index) of category.shortcuts">
              <div 
                :key    = "'d_' + index"
                class   = "description"
              >
                {{ shortcut.description }}
              </div>
              <div 
                :key    = "'k_' + index"
                class   = "keys"
              >
                <span
                  v-for   = "(key, index) of shortcut.keys"
                  :key    = "'key_' + index"
                  class   = "text-subtitle-1"
                >
                  <span class="key">{{ key }}</span>
                  <span 
                    class   = "separator"
                    v-if    = "index < shortcut.keys.length - 1"
                  >
                    {{ shortcut.range ? '...' : '+' }}
                  </span>
                </span>
              </div>
            </template>

          </div>

        </div>
      </div>

    </v-card>

  </v-dialog>

</template>

<script lang="js">

export default {

  // #region Properties

  name: 'HotkeyDialog',
  data() {
    return {
      keymap: {
        'shift+/': () => this.dialogIsOpen = true
      },
      dialogIsOpen: false,
      categories:   [
        {
          name:      'Playback',
          shortcuts: [
            {
              description: 'Toggle Playback',
              keys:        ['Space']
            },
            {
              description: 'Pause and reset playback rate',
              keys:        ['k']
            },
            {
              description: 'Decrease playback rate',
              keys:        ['j']
            },
            {
              description: 'Increase playback rate',
              keys:        ['l']
            },
            {
              description: 'Select next subtitle track',
              keys:        ['c']
            },
            {
              description: 'Toggle repeat',
              keys:        ['r']
            },
            {
              description: 'Mute audio',
              keys:        ['n']
            },
            {
              description: 'Select next audio track',
              keys:        ['ctrl', 'a']
            },
            {
              description: 'Toggle timecode overlay',
              keys:        ['t']
            },
            {
              description: 'Toggle fullscreen',
              keys:        ['f']
            }
          ]
        },
        {
          name:      'Timeline Navigation',
          shortcuts: [
            {
              description: 'Jump to beginning',
              keys:        ['Home']
            },
            {
              description: 'Jump to end',
              keys:        ['End']
            },
            {
              description: 'Jump one frame back',
              keys:        ['←']
            },
            {
              description: 'Jump ten frames back',
              keys:        ['Shift', '←']
            },
            {
              description: 'Jump ten seconds back',
              keys:        ['Ctrl', '←']
            },
            {
              description: 'Jump one frame forward',
              keys:        ['→']
            },
            {
              description: 'Jump ten frames forward',
              keys:        ['Shift', '→']
            },
            {
              description: 'Jump ten seconds forward',
              keys:        ['Ctrl', '→']
            },
            {
              description: 'Jump to 10% - 90%',
              keys:        ['1', '9'],
              range:       true
            },
            {
              description: 'Jump to live',
              keys:        ['g']
            },
            {
              description: 'Jump to previous flag',
              keys:        ['[']
            },
            {
              description: 'Jump to next flag',
              keys:        [']']
            },
            {
              description: 'Jump to previous I-frame',
              keys:        ['{']
            },
            {
              description: 'Jump to next I-frame',
              keys:        ['}']
            }
          ]
        },
        {
          name:      'In & Out Points',
          shortcuts: [
            {
              description: 'Set in point',
              keys:        ['i']
            },
            {
              description: 'Jump to in point',
              keys:        ['Shift', 'i']
            },
            {
              description: 'Clear in point',
              keys:        ['Ctrl', 'Shift', 'i']
            },
            {
              description: 'Set out point',
              keys:        ['o']
            },
            {
              description: 'Jump to out point',
              keys:        ['Shift', 'o']
            },
            {
              description: 'Clear out point',
              keys:        ['Ctrl', 'Shift', 'o']
            },
            {
              description: 'Log clip',
              keys:        ['p']
            }
          ]
        },
        {
          name:      'Waveform',
          shortcuts: [
            {
              description: 'Zoom out',
              keys:        ['-']
            },
            {
              description: 'Zoom in',
              keys:        ['+']
            }
          ]
        }
      ]
    }
  }

  // #endregion Properties

}

</script>

<style lang="scss" scoped>

@import '../../../styles/colors.scss';

.categories_container {
  display:        flex;
  flex-direction: row;
}

.keys_container {
  display:        grid;
  gap:            12px;
  padding:        16px;
  grid-template-columns:  1fr auto;

  .label {
    grid-column-start: 1;
    grid-column-end:   2;
  }

  .description {
    grid-column:      1;
    padding-top:      4px;

    text-align:       right;
    font-size:        0.9em;
    color:            $label-color;
  }

  .keys {
    grid-column:    2;

    .key {
      border:         1px solid white;
      border-radius:  4px;
      padding:        4px 10px 6px 10px;
      font-family:    Source Sans Pro;
    }

    .separator {
      margin:         0px 8px;
    }
  }
}

</style>
